import CognigyWebchat from '../cognigy-webchat';

const BASE_ASSET_URL = '/nsnl';

class NSNLCognigyWebchat extends CognigyWebchat {
  constructor() {
    super();
  }

  getBaseAssetUrl() {
    return BASE_ASSET_URL;
  }

  getNSPlatformName() {
    return 'ns-website';
  }

  //Defines the behavior of the webchat after it is loaded on the page
  defineStartupBehavior() {
    // 1) Open when the URL param is attached (when linked from the NS-App)
    if (this.nsAppScenarioId !== undefined) {
      return 'INIT_OPEN';
    }

    // 2) On smaller devices initialize minimized, but only if a session is active
    const isActive = this.isActive();
    const isFullscreen = this.isFullscreenDevice();
    if (isFullscreen) {
      return isActive ? 'INIT_MINIMIZED' : 'SKIP_INIT';
    }

    // 3) Previously minimized beats "previously open"
    const jensMinimized = localStorage.getItem('jens_minimized') === 'true';
    if (jensMinimized) return 'INIT_MINIMIZED';

    // 4) Previously open (or in handover) auto-opens
    const wasOpen =
      localStorage.getItem('jens_chatOpen') === 'true' ||
      localStorage.getItem('jens_handover') === 'true';
    if (wasOpen) return 'INIT_OPEN';

    // 5) Default desktop fallback: do not initialize
    return 'SKIP_INIT';
  }

  #closeHandler = () => {
    this.close();
  };
  #minimizeHandler = () => {
    this.minimize();
  };

  // Manage the minimize and close buttons
  manageHeaderButtons() {
    const minimizeButton = document.getElementsByClassName('webchat-header-minimize-button')[0];
    const closeButton = document.getElementsByClassName('webchat-header-close-button')[0];

    if (minimizeButton) {
      minimizeButton.addEventListener('click', this.#minimizeHandler);
    }

    if (closeButton) {
      closeButton.addEventListener('click', this.#closeHandler);
    }
  }

  // Send a minimize-event to Cognigy if webchat is minimized
  minimize() {
    this.webchat.updateSettings({
      widgetSettings: {
        disableToggleButton: false
      }
    });
    localStorage.setItem('jens_minimized', 'true');
    localStorage.setItem('jens_disableToggle', 'false');
  }
}

const cognigyWebchat = new NSNLCognigyWebchat();

window.CognigyWebchat = {
  open: async (initialMessage) => {
    await cognigyWebchat.open(initialMessage);
  },
  close: () => {
    cognigyWebchat.close();
  },
  addStateListener: (listener) => {
    return cognigyWebchat.addStateListener(listener);
  },
  isActive: () => {
    return cognigyWebchat.isActive();
  }
};

// Backward compatibility wrapper for old method name
window.openCognigyWebchat = window.CognigyWebchat.open;
